import axios from '@/request/http'
import querystring from 'querystring'
import ApiSetting from '@/request/api/setting'

const accountApi = {
  // authorizeUrl (params) {
  //   return axios.post(
  //     'libs/wechat/authorize-url/',
  //     querystring.stringify(params)
  //   )
  // },
  // userInfo (params) {
  //   return axios.post(
  //     'libs/wechat/user-info/',
  //     querystring.stringify(params)
  //   )
  // },
  // checkAccessToken (params) {
  //   return axios.post(
  //     'libs/wechat/check-access-token/',
  //     querystring.stringify(params)
  //   )
  // },
  login (params) {
    let url = ApiSetting.baseUrl + '/api-token-auth/'
    return axios.post(
      url,
      querystring.stringify(params)
    )
  }
  // updateUserInfo (params) {
  //   return axios.post(
  //     'libs/wechat/update-user-info/',
  //     querystring.stringify(params)
  //   )
  // },
  // getJSApiConfig (params) {
  //   return axios.get(
  //     `libs/wechat/get-jsapi-config/`,
  //     {params: params})
  // }
}

export default accountApi
